//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import IngresoAjusteManager from '../../../Common/Managers/IngresoAjusteManager';

export const GET_DATA_INGRESO_AJUSTES = 'GET_DATA_INGRESO_AJUSTES';
export const RECEIVE_DATA_INGRESO_AJUSTES = 'RECEIVE_DATA_INGRESO_AJUSTES';
export const CHANGE_DATA_INGRESO_AJUSTES = 'CHANGE_DATA_INGRESO_AJUSTES';
export const INITIAL_STATE_INGRESO_AJUSTES = 'INITIAL_STATE_INGRESO_AJUSTES';
export const EXPANDIR_ROW_INGRESO_AJUSTES = 'EXPANDIR_ROW_INGRESO_AJUSTES';
export const SUCCESS_INGRESO_AJUSTES = 'SUCCESS_INGRESO_AJUSTES';
export const LIMPIAR_INGRESO_AJUSTES = 'LIMPIAR_INGRESO_AJUSTES';
export const ELIMINAR_INGRESO_AJUSTES = 'ELIMINAR_INGRESO_AJUSTES';
export const EDITAR_INGRESO_AJUSTES = 'EDITAR_INGRESO_AJUSTES';
export const CONFIRMAR_INGRESO_AJUSTES = 'CONFIRMAR_INGRESO_AJUSTES';
export const DENEGAR_INGRESO_AJUSTES = 'DENEGAR_INGRESO_AJUSTES';
export const UPDATE_MOTIVO_AJUSTE_COMBO = 'UPDATE_MOTIVO_AJUSTE_COMBO';
export const CHANGE_IMPORTE_SIN_IVA = 'CHANGE_IMPORTE_SIN_IVA';
export const SELECCIONAR_RADIO = 'SELECCIONAR_RADIO';
export const ACTUALIZAR_DATA_MOTIVOAJUSTE = 'ACTUALIZAR_DATA_MOTIVOAJUSTE';
export const LOADING_INGRESO_AJUSTE = 'LOADING_INGRESO_AJUSTE';
export const SET_USER_FUNCTIONS_AJUSTES_CARGOS = 'SET_USER_FUNCTIONS_AJUSTES_CARGOS';
export const UPDATE_MONEDA_COMBO = 'UPDATE_MONEDA_COMBO';
export const UPDATE_DATA_MONEDA = 'UPDATE_DATA_MONEDA';
export const UPDATE_AJUSTE_CARGO_ESTADO = 'UPDATE_AJUSTE_CARGO_ESTADO';
export const REINICIAR_VALORES = 'REINICIAR_VALORES';
export const ACTUALIZA_REFERENCIA = 'ACTUALIZA_REFERENCIA';
export const OPEN_MODAL = 'OPEN_MODAL';
export const ERRORES_FORMULARIO = 'ERRORES_FORMULARIO';
export const OPEN_MODAL_INFO = 'OPEN_MODAL_INFO';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

let _dispatch, _codigo = "", _vistaCliente, _resetFields, _currentAccount, _executionContext, _currentScope, _permisos, _parametroGeneral, _idIva, _motivoAjusteDataFiltrado;

/**
 * Action que obtiene el estado inicial.
 * @param {any} currentScope
 * @param {any} currentAccount
 */
export function getScreenDataIngresoAjustes(currentScope, currentAccount) {
    LogHelper.In(getScreenDataIngresoAjustes.name, currentScope);

    return (dispatch, getState) => {
        let state = getState();

        _parametroGeneral = {
            ..._parametroGeneral,
            SINOCONFIRMACIONAJUSTES: state.DatosCuenta.parametroGeneral.SINOCONFIRMACIONAJUSTES,
            SINOCONFIRMACIONCARGOS: state.DatosCuenta.parametroGeneral.SINOCONFIRMACIONCARGOS
        }

        _idIva = state.tarjetas && state.tarjetas.Cliente ? state.tarjetas.Cliente.IDIVA : 0;
        _vistaCliente = JSON.parse(JSON.stringify(state.vistaCliente));

        _dispatch = dispatch;
        _currentAccount = currentAccount;

        _executionContext = state.DatosCuenta.sesion;
        _currentScope = state.DatosCuenta.currentScope;

        var currentScopeRequest = {
            UserId: _currentScope.UserId,
            ProductCode: _currentScope.ProductCode,
            ProgramCode: _currentScope.ProgramCode,
        };

        ConciergeProxy.Execute((data) => _loadUserFunctions(data), null, 'GETFUNCTIONS', currentScopeRequest);
    }
}


function _loadUserFunctions(data) {
    LogHelper.In(_loadUserFunctions.name, data);

    let functions = data.CARGAAJUSTES;
    let functionsAllowed = {};

    functions.forEach((p) => {
        functionsAllowed[p.Codigo_Funcion] = true;
    });

    _permisos = functionsAllowed;

    _dispatch({ type: GET_DATA_INGRESO_AJUSTES, functions: functionsAllowed });
    _dispatch({ type: SET_USER_FUNCTIONS_AJUSTES_CARGOS, functions: functionsAllowed, parametroGeneral: _parametroGeneral, executionContext: _executionContext });

    IngresoAjustes();
}

export function aceptar(ajuste, accion, resetFields, err, cuenta, ajusteEstados, cargoEstados, loginUsuario) {
    LogHelper.In(aceptar.name, ajuste, accion, resetFields, err, cuenta, ajusteEstados, cargoEstados, loginUsuario);

    return (dispatch, getState) => {
        if (accion == "guardar" && ajuste) {
            let msjErrorEstadoCuenta = validarEstadoCuenta(ajuste, cuenta);
            if (!validarDataAjusteCargo(accion, ajuste) && !err) {
                if (msjErrorEstadoCuenta == undefined) {
                    _dispatch({ type: LOADING_INGRESO_AJUSTE, valor: true });
                    //2-Debtio a la BD se le envia 0 / 1-Credito a la BD se le envia 1
                    let creditoDebtio = ajuste.DebitoCredito == 2 ? 1 : 0;
                    let paramAlta = {
                        'CUENTA_TARJETA_ID': _currentAccount,
                        'ID_CONCEPTO_MOTIVO': ajuste.AjusteCargoId,
                        'ID_ESTADO': ajuste.AjusteCargoEstadoId,
                        'FECHA_VALOR': ajuste.FechaPresentacion,
                        'ID_MONEDA': ajuste.AjusteMonedaId,
                        'ID_SUCURSAL': ajuste.SucursalId,
                        'IMPORTE_SIN_IVA': ajuste.ImporteSinIva,
                        'IMPORTE_IVA': ajuste.ImporteIVA,
                        'IMPORTE': ajuste.Importe,
                        'CANTIDAD_CUOTAS': ajuste.CantidadCuotas,
                        'USUARIO_ALTA': ajuste.UsuarioAlta,
                        'USUARIO_CONFIRMA': ajuste.UsuarioConfirmacion,
                        'FECHA_CONFIRMA': ajuste.FechaConfirmacion,
                        'REFERENCIA': ajuste.Referencia,
                        'DEBITO_CREDITO': creditoDebtio,
                        'INDICADOR': ajuste.IndicadorAjusteCargo
                    };
                    Engine1Proxy.AddDataSourcesRequests(paramAlta, 'ALTA_CARGO_AJUSTE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
                    Engine1Proxy.Execute((data) => _callBackAltaAjusteCargo(data, resetFields, ajuste, ajusteEstados, cargoEstados, cuenta, loginUsuario), null, null, "CONSULTASOCIOS");
                } else {
                    _dispatch({ type: OPEN_MODAL_INFO, valor: true, mensaje: msjErrorEstadoCuenta });
                    _dispatch({ type: LOADING_INGRESO_AJUSTE, valor: false });
                }
            }
        }
        else {
            if (accion = "edicion") {
                let msjErrorEstadoCuenta = validarEstadoCuenta(ajuste, cuenta);
                if (!validarDataAjusteCargo(accion, ajuste) && !err) {
                    if (msjErrorEstadoCuenta == undefined) {
                        //2-Credito a la BD se le envia 1 / 1-Debito a la BD se le envia 0 - NUevo
                        let creditoDebtio = ajuste.DebitoCredito == 2 ? 1 : 0;
                        switch (ajuste.TipoMovimiento) {
                            case 0:
                                ajuste.TipoMovimiento = "A"
                                break;
                            case 1:
                                ajuste.TipoMovimiento = "C"
                            default:
                                break;
                        }
                        let paramEdicion = {
                            'TIPO_MOVIMIENTO': "M",
                            'ID_AJUSTE': ajuste.TipoMovimiento == "A" ? ajuste.AjusteCargoId : null,
                            'ID_CARGO': ajuste.TipoMovimiento == "C" ? ajuste.AjusteCargoId : null,
                            'ID_MOTIVO': ajuste.AjusteMotivoId,
                            'ID_MONEDA': ajuste.AjusteMonedaId,
                            'IMPORTE_SIN_IVA': ajuste.ImporteSinIva,
                            'IMPORTE_IVA_AJUSTE': ajuste.ImporteIVAAjuste,
                            'IMPORTE_IVA_CARGO': ajuste.ImporteIVAAjuste,
                            'IMPORTE': ajuste.Importe,
                            'USER_MODIF': ajuste.UsuarioModificacion,
                            'REFERENCIA': ajuste.Referencia,
                            'DEBITO_CREDITO': creditoDebtio
                        };

                        _dispatch({ type: LOADING_INGRESO_AJUSTE, valor: true });

                        Engine1Proxy.AddDataSourcesRequests(paramEdicion, 'MODIFICACION_AJUSTE_CARGO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
                        Engine1Proxy.Execute(() => _callBackEdicionEliminacionAjuste(dispatch), null, null, "CONSULTASOCIOS");
                    }
                    else {
                        _dispatch({ type: OPEN_MODAL_INFO, valor: true, mensaje: msjErrorEstadoCuenta });
                        _dispatch({ type: LOADING_INGRESO_AJUSTE, valor: false });
                    }
                }
            }
        }
    }
}

function _callBackAltaAjusteCargo(data, resetFields, ajuste, ajusteEstados, cargoEstados, cuenta, loginUsuario) {
    resetFields();

    _dispatch({ type: REINICIAR_VALORES });
    _dispatch({ type: LOADING_INGRESO_AJUSTE, valor: false });

    let IdAjusteCargo = JSON.parse(data.ALTA_CARGO_AJUSTE).Recordset0.Rows[0].Id
    let EsConfirmado = JSON.parse(data.ALTA_CARGO_AJUSTE).Recordset0.Rows[0].EsConfirmado

    EsConfirmado ? confirmarAjusteCargo(ajuste, "Confirmar", ajusteEstados, cargoEstados, IdAjusteCargo, cuenta, loginUsuario) : IngresoAjustes(null);
}

function confirmarAjusteCargo(ajuste, estado, ajusteEstados, cargoEstados, IdAjusteCargo, cuenta, loginUsuario) {
    LogHelper.In(confirmarAjusteCargo.name, ajuste, estado, ajusteEstados, cargoEstados, IdAjusteCargo, cuenta, loginUsuario);
    let estadoId = null;
    _dispatch({ type: LOADING_INGRESO_AJUSTE, valor: true });
    let usuarioModificacion = loginUsuario;
    //Body para endpoint de Uala Ajustes y Cargos 
    let cuentaEntidadNumero = cuenta.CuentaEntidadNumero;
    let debitoCredito = ajuste.DebitoCredito == 2 ? "CREDIT" : "DEBIT";
    let importeSinIva = ajuste.ImporteSinIva;
    let codigo = ajuste.AjusteCargoId;
    let referencia = ajuste.Referencia;
    let monedaId = ajuste.AjusteMonedaId;
    let importeIva = ajuste.ImporteIVA;
    let importe = ajuste.Importe;
    switch (estado) {
        case "Confirmar":
            estadoId = "Confirmado";
            break;
        case "Denegar":
            estadoId = "Denegado";
            break;
        case "Restablecer":
            estadoId = "Pend. Confirmación";
            break;
        default:
            estadoId = estado;
            break;
    }
    if (ajuste.TipoMovimiento == "A") {
        estadoId = ajusteEstados.filter((ajusteEstado) => { return ajusteEstado.Descripcion == estadoId });
        estadoId = estadoId && estadoId.length > 0 ? estadoId[0].Id : undefined;
    } else {
        estadoId = cargoEstados.filter((cargoEstado) => { return cargoEstado.Descripcion == estadoId });
        estadoId = estadoId && estadoId.length > 0 ? estadoId[0].Id : undefined;
    }

    usuarioModificacion = (estadoId == 2 || estadoId == 7) ? usuarioModificacion : "";

    let parametrosConfirmacion = {
        ID_ESTADO: estadoId,
        TIPO_MOVIMIENTO: ajuste.IndicadorAjusteCargo ? 'C' : 'A',
        ID_MOVIMIENTO: IdAjusteCargo ? IdAjusteCargo : null,
        ES_FRONTERA: "0",
        USUARIO_MODIFICACION: usuarioModificacion,
        //BODY PARA WS UALA
        CUENTA_ENTIDAD_NUMERO: cuentaEntidadNumero,
        DEBITO_CREDITO: debitoCredito,
        IMPORTE_SIN_IVA: importeSinIva,
        IMPORTE_IVA: importeIva,
        IMPORTE: importe,
        CODIGO: codigo,
        REFERENCIA: referencia,
        MONEDA_ID: monedaId,
    };
    Engine1Proxy.AddRuleRequests(parametrosConfirmacion, 'CONFIRMADENIEGAAJUSTECARGO', 'Tarjetas', 'PREPAGO', 'Socios');
    Engine1Proxy.Execute((data) => _callBackConfirmacion(data), null, null, "PREPAGO");
}

function validarEstadoCuenta(objAjusteCargo, cuenta) {
    let msjErrorEstadoCuenta = undefined;
    //Si se seleccionó Credito(2) y el estado de la cuenta es diferente de 3(Operativa) se cancela el alta 
    if (objAjusteCargo.DebitoCredito == 2 && cuenta.estadoId != 3)
        msjErrorEstadoCuenta = "Solo es posible generar un movimiento de tipo Crédito para una cuenta Operativa";
    //Si se seleccionó Debito(1) y el estado de la cuenta es diferente de 3(Operativa) y 4(Inhabilitada) se cancela el alta 
    if (objAjusteCargo.DebitoCredito == 1 && (cuenta.estadoId != 3 && cuenta.estadoId != 4))
        msjErrorEstadoCuenta = "Solo es posible generar un movimiento de tipo Débito para una cuenta Operativa o Inhabilitada";
    return msjErrorEstadoCuenta;
}

function validarDataAjusteCargo(accion, objAjusteCargo) {
    LogHelper.In(validarDataAjusteCargo.name, accion, objAjusteCargo);
    let errorDebitoCredito = false, errorImporteSinIva = false, errorAjusteCargoSelect = false, errorEnAlta = false;

    if (!objAjusteCargo.AjusteCargoId) {
        errorAjusteCargoSelect = true;
        errorEnAlta = true;
    }
    else
        errorAjusteCargoSelect = false;

    if (objAjusteCargo.DebitoCredito == null || objAjusteCargo.DebitoCredito == 0) {
        errorDebitoCredito = true;
        errorEnAlta = true;
    }
    else
        errorDebitoCredito = false;

    if (objAjusteCargo.ImporteSinIva == undefined || isNaN(objAjusteCargo.ImporteSinIva) || objAjusteCargo.ImporteSinIva == "") {
        errorImporteSinIva = true;
        errorEnAlta = true;
    }
    else
        errorImporteSinIva = false;

    _dispatch({ type: ERRORES_FORMULARIO, errorDebitoCredito, errorAjusteCargoSelect, errorImporteSinIva });


    return errorEnAlta;
}

function _callBackEdicionEliminacionAjuste(dispatch) {
    dispatch({ type: LOADING_INGRESO_AJUSTE, valor: false });
    dispatch({ type: REINICIAR_VALORES });

    IngresoAjustes(null);
}

export function eliminar(ajuste, usuarioModif) {
    LogHelper.In(eliminar.name, ajuste, usuarioModif);

    let paramBaja = {
        'TIPO_MOVIMIENTO': "B",
        'ID_AJUSTE': ajuste.TipoMovimiento == "A" ? ajuste.Id : null,
        'ID_CARGO': ajuste.TipoMovimiento == "C" ? ajuste.Id : null,
        'ID_MOTIVO': null,
        'ID_MONEDA': null,
        'IMPORTE_SIN_IVA': null,
        'IMPORTE_IVA_AJUSTE': null,
        'IMPORTE_IVA_CARGO': null,
        'IMPORTE': null,
        'USER_MODIF': usuarioModif,
        'REFERENCIA': null,
        'DEBITO_CREDITO': null
    };

    Engine1Proxy.AddDataSourcesRequests(paramBaja, 'MODIFICACION_AJUSTE_CARGO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.Execute(() => _callBackEdicionEliminacionAjuste(_dispatch), null, null, "CONSULTASOCIOS");

    return (dispatch, getState) => {
        dispatch({ type: LOADING_INGRESO_AJUSTE, valor: true });
    }
}

export function editar(ajuste) {
    LogHelper.In(editar.name, ajuste);

    let paramAjustes = {
        'TIPO_MOVIMIENTO': ajuste.TipoMovimiento == "A" ? 0 : 1,
        'CUENTA_TARJETA_ID': _currentAccount,
        'ID_IVA': _idIva,
        'ID_MOTIVO': ajuste.MotivoId
    };

    let params = {
        'MOTIVO_AJUSTE_ID': ajuste.MotivoId,
        'CUENTA_TARJETA_ID': _currentAccount
    };

    _dispatch({ type: REINICIAR_VALORES });

    Engine1Proxy.AddDataSourcesRequests(params, 'GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(paramAjustes, 'GET_TIPOS_AJUSTES_CARGOS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.Execute((data) => _callBackEditar(data, ajuste), null, null, "CONSULTASOCIOS");

    return (dispatch, getState) => {
        dispatch({ type: LOADING_INGRESO_AJUSTE, valor: true });
    }
}

function _callBackEditar(data, ajuste) {
    let comboMotivos = JSON.parse(data.GET_TIPOS_AJUSTES_CARGOS).Recordset0.Rows ? JSON.parse(data.GET_TIPOS_AJUSTES_CARGOS).Recordset0.Rows : undefined;
    let motivoAjuste = JSON.parse(data.GET_TIPOS_AJUSTES_CARGOS).Recordset1.Rows ? JSON.parse(data.GET_TIPOS_AJUSTES_CARGOS).Recordset1.Rows : undefined;
    let GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID = JSON.parse(data.GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID);

    let tipoMoneda = ajuste.TipoMovimiento == "A" ? GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID.Recordset1.Rows : GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID.Recordset4.Rows;

    let resultado = {
        motivoAjusteData: motivoAjuste
    };

    let ajusteCargoRD = ajuste.TipoMovimiento == "A" ? 0 : 1;

    _dispatch({ type: UPDATE_DATA_MONEDA, data: tipoMoneda });
    _dispatch({ type: EDITAR_INGRESO_AJUSTES, ajuste: ajuste, resultado });
    _dispatch({ type: ACTUALIZAR_DATA_MOTIVOAJUSTE, data: comboMotivos });
    _dispatch({ type: LOADING_INGRESO_AJUSTE, valor: false });
    _dispatch({ type: SELECCIONAR_RADIO, campo: "ajusteCargoRdButton", valor: ajusteCargoRD });
    _dispatch({ type: CHANGE_IMPORTE_SIN_IVA, numero: ajuste.ImporteSinIVA , esError: false });
}

export function actualizaReferencia(referencia) {
    LogHelper.In(actualizaReferencia.name, referencia);

    return (dispatch, getState) => {
        dispatch({ type: ACTUALIZA_REFERENCIA, referencia });
    }
}

export function cambiarImporteConIva(numero, esError) {
    LogHelper.In(cambiarImporteConIva.name, numero, esError);

    return (dispatch, getState) => {
        dispatch({ type: CHANGE_IMPORTE_SIN_IVA, numero, esError });
    }
}

export function getCodigo(ajuste, estado, ajusteEstados, cargoEstados) {
    LogHelper.In(getCodigo.name, ajuste);
    return (dispatch, getState) => {
        let stateAjustes = getState().ingresoAjustes.data;
        let stateTarjetas = getState().tarjetas;
        _dispatch = dispatch;
        let param = {
            TIPO_MOVIMIENTO: ajuste.TipoMovimiento,
            MOTIVO_ID: ajuste.MotivoId
        };
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_MOTIVO_BY_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.Execute((data) => _callBackGetCodigo(data, ajuste, estado, ajusteEstados, cargoEstados, stateAjustes, stateTarjetas), null, null, "CONSULTASOCIOS");
    }
}

function _callBackGetCodigo(data, ajuste, estado, ajusteEstados, cargoEstados, stateAjustes, stateTarjetas) {
    _codigo = JSON.parse(data.GET_MOTIVO_BY_ID).Recordset0.Rows ? JSON.parse(data.GET_MOTIVO_BY_ID).Recordset0.Rows[0].CODIGO : "";
    confirmar(ajuste, estado, ajusteEstados, cargoEstados, stateAjustes, stateTarjetas);
}

export function confirmar(ajuste, estado, ajusteEstados, cargoEstados, stateAjustes, stateTarjetas) {
    LogHelper.In(confirmar.name, ajuste, estado);
    let estadoId = null;

    _dispatch({ type: LOADING_INGRESO_AJUSTE, valor: true });

    let usuarioModificacion = stateAjustes && stateAjustes.executionContext ? stateAjustes.executionContext.login : "";

    //Body para endpoint de Uala Ajustes y Cargos 
    let cuentaEntidadNumero = stateTarjetas.cuentaCorriente.CuentaEntidadNumero;
    let debitoCredito = ajuste.DebitoCredito ? "CREDIT" : "DEBIT";
    let importeSinIva = ajuste.ImporteSinIVA;
    let codigo = _codigo;
    let referencia = ajuste.Referencia;
    let monedaId = ajuste.MonedaId;
    let importeIva = ajuste.ImporteIVA;
    let importe = ajuste.MonedaId ? ajuste.ImporteTotalPesos : ajuste.ImporteTotalDolares;

    switch (estado) {
        case "Confirmar":
            estadoId = "Confirmado";
            break;
        case "Denegar":
            estadoId = "Denegado";
            break;
        case "Restablecer":
            estadoId = "Pend. Confirmación";
            break;
        default:
            estadoId = estado;
            break;
    }

    if (ajuste.TipoMovimiento == "A") {
        estadoId = ajusteEstados.filter((ajusteEstado) => { return ajusteEstado.Descripcion == estadoId });
        estadoId = estadoId && estadoId.length > 0 ? estadoId[0].Id : undefined;
    } else {
        estadoId = cargoEstados.filter((cargoEstado) => { return cargoEstado.Descripcion == estadoId });
        estadoId = estadoId && estadoId.length > 0 ? estadoId[0].Id : undefined;
    }

    usuarioModificacion = (estadoId == 2 || estadoId == 7) ? usuarioModificacion : "";

    let parametrosConfirmacion = {
        ID_ESTADO: estadoId,
        TIPO_MOVIMIENTO: ajuste.TipoMovimiento,
        ID_MOVIMIENTO: ajuste.Id,
        ES_FRONTERA: "0",
        USUARIO_MODIFICACION: usuarioModificacion,
        //BODY PARA WS UALA
        CUENTA_ENTIDAD_NUMERO: cuentaEntidadNumero,
        DEBITO_CREDITO: debitoCredito,
        IMPORTE_SIN_IVA: importeSinIva,
        IMPORTE_IVA: importeIva,
        IMPORTE: importe,
        CODIGO: codigo,
        REFERENCIA: referencia,
        MONEDA_ID: monedaId,
    };

    Engine1Proxy.AddRuleRequests(parametrosConfirmacion, 'CONFIRMADENIEGAAJUSTECARGO', 'Tarjetas', 'PREPAGO', 'Socios');
    Engine1Proxy.Execute((data) => _callBackConfirmacion(data), null, null, "PREPAGO");

}

function _callBackConfirmacion(data) {
    let codigoWSUala = JSON.parse(data.CONFIRMADENIEGAAJUSTECARGO);

    switch (codigoWSUala) {
        case "200":
            _dispatch({ type: OPEN_MODAL_INFO, valor: true, mensaje: "El movimiento se ha generado de manera exitosa." });
            break;
        case "429":
            _dispatch({ type: OPEN_MODAL_INFO, valor: true, mensaje: "Se está cursando la operación requerida, favor de consultar más tarde por su estado." });
            break;
        case "400":
            _dispatch({ type: OPEN_MODAL_INFO, valor: true, mensaje: "El movimiento no se pudo impactar en el procesador, por favor verifique e intente nuevamente." });
            break;
        default:
            _dispatch({ type: OPEN_MODAL_INFO, valor: true, mensaje: "Hubo un error al procesar el movimiento. Por favor comuniquese con soporte técnico para recibir asistencia y solucionarlo lo antes posible." });
            break;
    }

    _dispatch({ type: LOADING_INGRESO_AJUSTE, valor: false });
}

export function denegar(ajuste, estado) {
    LogHelper.In(denegar.name, ajuste, estado);

    return (dispatch, getState) => {
        let state = getState();
        ajuste.AjusteEstadoId = estado;
        ajuste.FechaCambioEstado = new Date();
        ajuste.UsuarioUltModif = state.sesion.executionContext.login;
        _vistaCliente = JSON.parse(JSON.stringify(state.vistaCliente));
        dispatch({ type: DENEGAR_INGRESO_AJUSTES });
        IngresoAjusteManager.ActualizarAjuste(ajuste, () => IngresoAjustes());

    }
}
/** 
 * Action que obtiene el estado inicial.
 */
export function resetStateIngresoAjustes() {
    LogHelper.In(resetStateIngresoAjustes.name);

    return (dispatch) => {
        dispatch({ type: INITIAL_STATE_INGRESO_AJUSTES });
    }
}

export function expandirRow(id) {
    LogHelper.In(expandirRow.name, id);

    return (dispatch) => {
        dispatch({ type: EXPANDIR_ROW_INGRESO_AJUSTES, id: id });
    }
}

export function seleccionarMotivo(id, resetFields) {
    LogHelper.In(seleccionarMotivo.name, id);
    return (dispatch, getState) => {
        let motivoAjusteData = getState().ingresoAjustes.data.motivoAjusteData;
        resetFields();
        if (id != 0) {
            dispatch({ type: LOADING_INGRESO_AJUSTE, valor: true });
            _motivoAjusteDataFiltrado = motivoAjusteData ? motivoAjusteData.filter(x => x.IdMotivo == id) : undefined;
            _motivoAjusteDataFiltrado = _motivoAjusteDataFiltrado && _motivoAjusteDataFiltrado.length > 0 ? _motivoAjusteDataFiltrado[0] : undefined;
            _motivoAjusteDataFiltrado.ajusteCargoRdButton = getState().ingresoAjustes.data.ajusteCargoRdButton;

            dispatch({ type: UPDATE_MOTIVO_AJUSTE_COMBO, id, motivoAjusteDataFiltrado: _motivoAjusteDataFiltrado });

            let params = {
                'MOTIVO_AJUSTE_ID': id,
                'CUENTA_TARJETA_ID': _currentAccount
            };
            let paramsExtra = {
                'ADMINISTRADORA_ID': 3,
                'CUENTA_TARJETA_ID': _currentAccount
            };


            Engine1Proxy.AddDataSourcesRequests(paramsExtra, 'GET_AJUSTES_DATOS_EXTRAS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(params, 'GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
            Engine1Proxy.Execute((data) => _filterIngresoAjustesData(data, _motivoAjusteDataFiltrado.ajusteCargoRdButton), null, null, "CONSULTASOCIOS");
        } else {
            _dispatch({ type: UPDATE_DATA_MONEDA, data: [] });
            dispatch({ type: UPDATE_MOTIVO_AJUSTE_COMBO, id: 0, motivoAjusteDataFiltrado: undefined });
        }
    }
}

export function seleccionarMoneda(id) {
    LogHelper.In(seleccionarMoneda.name, id);
    return (dispatch, getState) => {
        dispatch({ type: UPDATE_MONEDA_COMBO, id });
    }
}

export function openModalAjustesCargos(abrirModal, resetFields, mostrarModalConfirmacion, mostrarModalesError) {
    LogHelper.In(openModalAjustesCargos.name);
    return (dispatch, getState) => {
        _resetFields = resetFields ? resetFields : _resetFields;
        dispatch({ type: OPEN_MODAL, valor: abrirModal, mostrarModalConfirmacion, mostrarModalesError });
    }
}


export function ocultarModalInfoAjustesCargos() {
    _dispatch({ type: REINICIAR_VALORES });

    IngresoAjustes(null);

    return (dispatch, getState) => {
        dispatch({ type: OPEN_MODAL_INFO, valor: false });
    }
}

export function limpiarForm() {
    return (dispatch, getState) => {
        _resetFields();
        dispatch({ type: REINICIAR_VALORES });
    }
}

export function selectRadioIngresoAjustes(campo, valor, resetFields) {
    return (dispatch, getState) => {
        _dispatch = dispatch;

        if (resetFields)
            resetFields();

        _dispatch({ type: SELECCIONAR_RADIO, campo, valor });

        if (campo == "ajusteCargoRdButton") {
            _dispatch({ type: LOADING_INGRESO_AJUSTE, valor: true });
            _dispatch({ type: REINICIAR_VALORES });
            _dispatch({ type: SELECCIONAR_RADIO, campo, valor });

            let paramAjustes = {
                'TIPO_MOVIMIENTO': valor,
                'CUENTA_TARJETA_ID': _currentAccount,
                'ID_IVA': _idIva,
                'ID_MOTIVO': null
            };

            Engine1Proxy.AddDataSourcesRequests(paramAjustes, 'GET_TIPOS_AJUSTES_CARGOS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
            Engine1Proxy.Execute((data) => _callBackGetTipoAjustes(data), null, null, "CONSULTASOCIOS");
        } else {
            _dispatch({ type: SELECCIONAR_RADIO, campo, valor });
        }
    }
}

/*-------------------FUNCIONES AUXILIARES-------------------------*/

function _callBackGetTipoAjustes(data) {
    let motivoAjusteData = JSON.parse(data.GET_TIPOS_AJUSTES_CARGOS).Recordset0.Rows ? JSON.parse(data.GET_TIPOS_AJUSTES_CARGOS).Recordset0.Rows : undefined;

    _dispatch({ type: ACTUALIZAR_DATA_MOTIVOAJUSTE, data: motivoAjusteData });
    _dispatch({ type: LOADING_INGRESO_AJUSTE, valor: false });
}

function _filterIngresoAjustesData(data, tipoMovimiento) {
    let GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID = JSON.parse(data.GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID);
    let GET_AJUSTES_DATOS_EXTRAS = JSON.parse(data.GET_AJUSTES_DATOS_EXTRAS);

    let ajusteEstados = GET_AJUSTES_DATOS_EXTRAS.Recordset4.Rows ? GET_AJUSTES_DATOS_EXTRAS.Recordset4.Rows : undefined;
    let cargoEstados = GET_AJUSTES_DATOS_EXTRAS.Recordset5.Rows ? GET_AJUSTES_DATOS_EXTRAS.Recordset5.Rows : undefined;

    //0 = AJUSTE, 1 = CARGO
    let tipoMoneda = tipoMovimiento == 0 ? GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID.Recordset1.Rows : GET_AJUSTES_REGISTRADOS_BY_AJUSTE_MOTIVO_ID.Recordset4.Rows;
    _dispatch({ type: UPDATE_DATA_MONEDA, data: tipoMoneda });
    _dispatch({ type: UPDATE_AJUSTE_CARGO_ESTADO, ajusteEstados: ajusteEstados, cargoEstados: cargoEstados });
    _dispatch({ type: LOADING_INGRESO_AJUSTE, valor: false });
}

function getIngresoAjustesData(data, dispatch, motivoId) {
    let GET_AJUSTES_REGISTRADOS_DESDE_ULTIMO_CIERRE = JSON.parse(data.GET_AJUSTES_REGISTRADOS_DESDE_ULTIMO_CIERRE);
    let motivoAjusteData = JSON.parse(data.GET_TIPOS_AJUSTES_CARGOS).Recordset0.Rows ? JSON.parse(data.GET_TIPOS_AJUSTES_CARGOS).Recordset0.Rows : undefined;
    let GET_AJUSTES_CARGOS_REGISTRADOS_GRILLA = JSON.parse(data.GET_AJUSTES_CARGOS_REGISTRADOS_GRILLA);
    const GET_AJUSTES_DATOS_EXTRAS = JSON.parse(data.GET_AJUSTES_DATOS_EXTRAS);

    let result = {
        ajustes: GET_AJUSTES_CARGOS_REGISTRADOS_GRILLA.Recordset0.Rows,
        siNoConfirmacion: GET_AJUSTES_CARGOS_REGISTRADOS_GRILLA.Recordset1.Rows,
        tipoMoneda: [],
        fechaCobranza: GET_AJUSTES_REGISTRADOS_DESDE_ULTIMO_CIERRE.Recordset2.Rows[0].FechaCobranza,
        ajusteMotivo: GET_AJUSTES_REGISTRADOS_DESDE_ULTIMO_CIERRE.Recordset3.Rows,
        sucursalId: GET_AJUSTES_DATOS_EXTRAS.Recordset0.Rows[0] ? GET_AJUSTES_DATOS_EXTRAS.Recordset0.Rows[0].SucursalId : undefined,
        ajusteEstadoId: GET_AJUSTES_DATOS_EXTRAS.Recordset1.Rows[0] ? GET_AJUSTES_DATOS_EXTRAS.Recordset1.Rows[0].Id : undefined,
        ajusteOrigenId: GET_AJUSTES_DATOS_EXTRAS.Recordset2.Rows[0] ? GET_AJUSTES_DATOS_EXTRAS.Recordset2.Rows[0].Id : undefined,
        tarjetaCreditoId: GET_AJUSTES_DATOS_EXTRAS.Recordset3.Rows[0] ? GET_AJUSTES_DATOS_EXTRAS.Recordset3.Rows[0].Id : undefined,
        motivoAjusteData: motivoAjusteData,
        tarjetaVigencia: GET_AJUSTES_REGISTRADOS_DESDE_ULTIMO_CIERRE.Recordset4.Rows,
        cuentaTarjetaId: _currentAccount,
        permisos: _permisos,
        parametroGeneral: _parametroGeneral,
        executionContext: _executionContext,
        ajusteEstados: GET_AJUSTES_DATOS_EXTRAS.Recordset4.Rows ? GET_AJUSTES_DATOS_EXTRAS.Recordset4.Rows : undefined,
        cargoEstados: GET_AJUSTES_DATOS_EXTRAS.Recordset5.Rows ? GET_AJUSTES_DATOS_EXTRAS.Recordset5.Rows : undefined
    }

    dispatch({ type: RECEIVE_DATA_INGRESO_AJUSTES, data: result, motivoId });
}

function IngresoAjustes(motivoAjusteId) {
    _dispatch({ type: LOADING_INGRESO_AJUSTE, valor: true });

    let params = {
        'ADMINISTRADORA_ID': 3,
        'CUENTA_TARJETA_ID': _currentAccount
    };
    let paramAjustes = {
        'TIPO_MOVIMIENTO': 0,
        'CUENTA_TARJETA_ID': _currentAccount,
        'ID_IVA': _idIva,
        'ID_MOTIVO': null
    };
    let paramsGrilla = {
        'CUENTA_TARJETA_ID': _currentAccount
    };

    Engine1Proxy.AddDataSourcesRequests(paramAjustes, 'GET_TIPOS_AJUSTES_CARGOS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(params, 'GET_AJUSTES_REGISTRADOS_DESDE_ULTIMO_CIERRE', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(params, 'GET_AJUSTES_DATOS_EXTRAS', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(paramsGrilla, 'GET_AJUSTES_CARGOS_REGISTRADOS_GRILLA', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
    Engine1Proxy.Execute((data) => getIngresoAjustesData(data, _dispatch, motivoAjusteId), null, null, "CONSULTASOCIOS");
}